import { useMediaQuery } from '@mui/material';
import { useTranslation } from 'react-i18next';

import AddedByCell from './Cells/AddedByCell';

import { MediaBreakpoints } from 'hooks/Screen/useScreenSize';
import { Document } from 'api/objectDocs/type';
import { MLButton } from 'components/Button/Button';

interface ExpandableObjectDocsProps {
  data: Document;
  slug: string;
  onDeleteClick: (docID: number, docName: string) => void;
}

const ExpandableObjectDocs: React.FC<ExpandableObjectDocsProps> = ({ data, onDeleteClick }) => {
  const { t } = useTranslation();
  const mobile = useMediaQuery(MediaBreakpoints.mobile);
  const tablet = useMediaQuery(MediaBreakpoints.tablet);
  const largeDesktop = useMediaQuery(MediaBreakpoints.largeDesktop);

  return (
    <div className="d-flex w-100 flex-column">
      {largeDesktop && (
        <div className="d-flex flex-column my-2">
          <div>
            <span className="me-1 fs-14 fw-bold">{t('ObjectDocs.doc-table.file-size')}</span>
          </div>
          <div className="border-bottom pb-2">{data.file_size}</div>
        </div>
      )}
      {tablet && (
        <div className="d-flex flex-column my-2">
          <div>
            <span className="me-1 fs-14 fw-bold">{t('ObjectDocs.doc-table.added-by')}</span>
          </div>
          <div className="border-bottom pb-2">
            <AddedByCell data={data.uploaded_by} />
          </div>
        </div>
      )}
      {mobile && (
        <>
          <div className="d-flex flex-column my-2">
            <div>
              <span className="me-1 fs-14 fw-bold">{t('ObjectDocs.doc-table.upload-date')}</span>
            </div>
            <div className="border-bottom pb-2">{data.upload_date}</div>
          </div>
          <div className="d-flex flex-column my-2">
            <div>
              <span className="me-1 fs-14 fw-bold">{t('ObjectDocs.doc-table.action')}</span>
            </div>
            <div className="border-bottom pb-2">
              {data.is_archived ? (
                <MLButton disabled innerText={t('ObjectDocs.doc-table.archived')} />
              ) : (
                <MLButton
                  onClick={() => onDeleteClick(data.id, data.doc_name)}
                  innerText={t('ObjectDocs.doc-table.btn')}
                />
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default ExpandableObjectDocs;
